import { UPDATE_STUDENT_DATA, RESET_STUDENT_DATA } from "../actions";

const INITIAL_STATE = {
  id: null,
  first_name: "",
  phone: "",
  father_name: "",
  dob: "",
  classroom_name: "",
  badge_id: "",
  parent_name: "",
  parent_phone: "",
  feeDues: [],
  feePaid: [],
  isLoading: false,
  studentList: [],
  feeNotes: [],
  refundDetails: [],
  totalFee: [],
  filteredStudentsLength: null,
  institutes_tracks_id: null,
  assignedFeeBundles: [],
  feeBundleDetails: [],
  unallocatedAmount: 0,
  unAssignedFeeBundles: [],
  totalFeeDue: null,
  totalFeePaid: null,
};

const studentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_STUDENT_DATA:
      return { ...state, ...action.payload };
    case RESET_STUDENT_DATA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default studentReducer;
